import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoginModule } from './login';
import { HomeModule } from './home';
import { ClientsModule } from './clients';

import { AdminComponent } from './admin.component';
import { OrdersHistoryModule } from './orders-history';
import { PartnersModule } from './partners';
import { ManageQuotationModule } from './manage-quotation/manage-quotation.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoginModule,
    HomeModule,
    ClientsModule,
    OrdersHistoryModule,
    PartnersModule,
    ManageQuotationModule,
  ],
  declarations: [AdminComponent],
})
export class AdminModule {}
